(() => {
  const drawer = document.querySelector('cart-drawer');

  if (!drawer) return;

  const surfaceSelector = "[data-testid='POPUP'], [data-testid='FLYOUT'], [data-testid='FULL_PAGE']";
  const closeButtonSelector =
    "button[aria-label='Close dialog'], button[aria-label='Close form'], button[data-testid*='close']";
  let suppressionQueued = false;
  let bodyObserverActive = false;

  const drawerIsOpen = () => drawer.classList.contains('active');

  const findSurface = (element) => {
    const identifiedSurface = element.closest(surfaceSelector);

    if (identifiedSurface) return identifiedSurface;

    let current = element;
    let candidate = null;

    while (current && current !== document.body) {
      if (current.matches('form.klaviyo-form') || current.querySelector?.('form.klaviyo-form')) {
        candidate = current;
      }
      current = current.parentElement;
    }

    return candidate;
  };

  const suppressSurface = (surface) => {
    if (!surface) return;

    surface.setAttribute('data-asili-cart-suppressed', 'true');
    surface.setAttribute('aria-hidden', 'true');
  };

  const suppressKlaviyoForms = () => {
    suppressionQueued = false;

    if (!drawerIsOpen()) return;

    document.body.classList.add('asili-cart-drawer-open');
    document.querySelectorAll(surfaceSelector).forEach(suppressSurface);

    document.querySelectorAll(closeButtonSelector).forEach((button) => {
      const surface = findSurface(button);
      const isKlaviyoButton =
        Boolean(surface) ||
        button.classList.contains('needsclick') ||
        Boolean(button.closest("[class*='kl-private-reset-css']"));

      if (!isKlaviyoButton) return;

      suppressSurface(surface);
      button.click();
    });
  };

  const queueSuppression = () => {
    if (suppressionQueued || !drawerIsOpen()) return;

    suppressionQueued = true;
    requestAnimationFrame(suppressKlaviyoForms);
  };

  const bodyObserver = new MutationObserver((records) => {
    const addedContent = records.some((record) => record.addedNodes.length > 0);
    if (addedContent) queueSuppression();
  });

  const syncDrawerState = () => {
    const open = drawerIsOpen();
    document.body.classList.toggle('asili-cart-drawer-open', open);

    if (open) {
      if (!bodyObserverActive) {
        bodyObserver.observe(document.body, {
          childList: true,
          subtree: true,
        });
        bodyObserverActive = true;
      }

      queueSuppression();
      return;
    }

    if (bodyObserverActive) {
      bodyObserver.disconnect();
      bodyObserverActive = false;
    }
  };

  new MutationObserver(syncDrawerState).observe(drawer, {
    attributes: true,
    attributeFilter: ['class'],
  });

  window.addEventListener(
    'klaviyoForms',
    (event) => {
      if (event.detail?.type === 'open') queueSuppression();
    },
    true,
  );

  syncDrawerState();
})();
